import breakpoints from '../data/breakpoints';
import Slider from '../components/slider';
import $ from 'jquery';
class Subpages {
    constructor(el) {
        this.el = el;
        this.sliderEl = el.find('.slider');
        this.slider = new Slider(this.sliderEl, {
            dots: true,
            mobileFirst: false,
            arrows: false,
            fade: false,
            slidesToShow: 1,
            variableWidth: false,
            rows: 3,
            responsive: [
                {
                    breakpoint: breakpoints.tablet - 1,
                    settings: 'unslick'
                },
                {
                    breakpoint: breakpoints.desktop - 1,
                    settings: {
                        slidesToShow: 2,
                        rows: 2
                    }
                },
                {
                    breakpoint: 999999,
                    settings: 'unslick'
                },
            ]
        });
        this.slickTrackEl = el.find('.slick-list');
        $(window).resize(() => {
        }).resize();
    }
}
export default Subpages;